import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconMobileApplications = ({
  title = "Mobile Applications",
  color = "gray",
  viewBoxWidth = 34,
  viewBoxHeight = 34,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g id="IconMobileApplications" strokeWidth="1">
      <path
        d="M15,18 C15.5522847,18 16,18.4477153 16,19 L16,33 C16,33.5522847 15.5522847,34 15,34 L1,34 C0.44771525,34 0,33.5522847 0,33 L0,19 C0,18.4477153 0.44771525,18 1,18 L15,18 Z M14,20 L2,20 L2,32 L14,32 L14,20 Z M30,29 L30,31 L18,31 L18,29 L30,29 Z M30,25 L30,27 L18,27 L18,25 L30,25 Z M34,21 L34,23 L18,23 L18,21 L34,21 Z M15,0 C15.5522847,0 16,0.44771525 16,1 L16,15 C16,15.5522847 15.5522847,16 15,16 L1,16 C0.44771525,16 0,15.5522847 0,15 L0,1 C0,0.44771525 0.44771525,0 1,0 L15,0 Z M14,2 L2,2 L2,14 L14,14 L14,2 Z M26,11 L26,13 L18,13 L18,11 L26,11 Z M34,7 L34,9 L18,9 L18,7 L34,7 Z M34,3 L34,5 L18,5 L18,3 L34,3 Z"
        fill={uiColorToBaseColor(color)}
      />
    </g>
  </Svg.Icon>
)

export default IconMobileApplications
